<template>
	<div id="createDCWrapper" class="flex-grow flex flex-col" v-if="isUserAllowedInLevel5or6 && isAppContainer">
		<DamageAssessor
			v-show="pageIndex === pageIndexEnum.DamageAssessor"
			@next="next($event)"
			@previous="previous()"
			:start-value="apiData.damageAssessor"
		/>
		<OverviewImage v-show="pageIndex === pageIndexEnum.OverviewImage" @next="next($event)" @previous="previous()" :is-back-button="true" />
		<LawyerAuthority
			v-show="pageIndex === pageIndexEnum.LawyerAuthority"
			@next="next($event)"
			@previous="previous()"
			@clearLawyerOffice="clearLawyerOffice"
      @skipLawyerOffice="apiData.isSkipLawyerOffice=$event"
		/>
		<ForeignLawyerOffice
			v-show="pageIndex === pageIndexEnum.ForeignLawyerOffice"
			@next="next($event)"
			@previous="previous()"
			:lawyer-office="apiData.lawyerOffice"
		/>
		<MailToLawyer v-show="pageIndex === pageIndexEnum.MailToLawyer" @next="next($event)" @previous="previous()" :api-data="apiData" />
		<OppositePerson v-show="pageIndex === pageIndexEnum.OppositePerson" @next="next($event)" @previous="previous()" />
		<Accident v-show="pageIndex === pageIndexEnum.Accident" @next="next($event)" @previous="previous()" />
		<Submit
			v-show="pageIndex === pageIndexEnum.Submit"
			:is-shown="pageIndex === pageIndexEnum.Submit"
			@next="next()"
			:damage-case="apiData"
			@previous="previous()"
		/>
	</div>
	<Forbidden v-else />
</template>

<script>
import DamageAssessor from '@/components/damagecases/pages/DamageAssessor';
import LawyerAuthority from '@/components/damagecases/pages/LawyerAuthority';
import stateMerge from 'vue-object-merge';
import Accident from '@/components/damagecases/pages/Accident';
import OverviewImage from '@/components/damagecases/pages/OverviewImage';
import Submit from '@/components/damagecases/pages/Submit';
import OppositePerson from '@/components/damagecases/pages/OppositePerson';
import LoadingSpinner from '@/mixins/LoadingSpinner';
import { VehiclesApiFactory, CustomersApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import MailToLawyer from '@/components/damagecases/pages/MailToLawyer';
import ForeignLawyerOffice from '@/components/damagecases/pages/ForeignLawyerOffice';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';
import AppContainerMixin from '@/mixins/AppContainerMixin';

const vehiclesApi = VehiclesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios);
const customersApi = CustomersApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios);

export default {
	name: 'DamagecaseCreate',
	components: {
		Forbidden,
		ForeignLawyerOffice,
		MailToLawyer,
		OppositePerson,
		Submit,
		OverviewImage,
		Accident,
		LawyerAuthority,
		DamageAssessor,
	},
	mixins: [LoadingSpinner, Authentication, AppContainerMixin],
	mounted() {
		this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
		this.me = this.$store.getters.getUser;

		// Wenn Customer übergeben wurde, müssen seine Fahrzeuge ausgelesen werden
		if (this.$route.params.customer || this.$route.query.customer_id) {
			customersApi.customersIdGet(parseInt(this.$route.params.customer || this.$route.query.customer_id)).then(response => {
				this.apiData.customer = response.data;
				this.getCustomerCars();
			});
			/*
      TODO: Test
      CustomerRepository.show(this.$route.params.customer || this.$route.query.customer_id).then(response => {
        this.apiData.customer = response.data;
        this.getCustomerCars();
      });
      */
		}
	},
	watch: {
		pageIndex: function() {
			this.$emit('scrollUp', this.pageIndex);
		},
	},
	data() {
		return {
			me: {},
			customerCars: [],
			rentalCars: [],
			defaultSignLocation: '',
			pageRegister: [],
			pageRegisterIndex: 0,
			pageIndexEnum: {
				LawyerAuthority: 5,
				Accident: 1,
				OverviewImage: 0,
				Submit: 8,
				OppositePerson: 2,
				MailToLawyer: 7,
				DamageAssessor: 3,
				ForeignLawyerOffice: 6,
			},
			pageIndex: 0,
			apiData: {
				repairOrder: this.$t('repair_billing_expertise'),
				isPersonInjured: null,
				isRecordedByPolice: null,
				date: null,
				accidentLocation: null,
				workflowSelections: {
					expertContract: true,
					lawyerAuthority: false,
					paymentOrder: false,
					repairContract: false,
					rentalCarContract: false,
				},
				DamageAssessor: {},
				damageAssessorNonSystemPartner: false,
        isSkipLawyerOffice: false,
				opposite_case_number: null,
				opposite_insurance_contract_number: null,
				insurance: null,
				customer: {
					id: null,
					gender: null,
					title: null,
					firstName: null,
					lastName: null,
					street: null,
					houseNumber: null,
					city: {
						id: null,
					},
					phoneNumber: null,
					email: null,
				},
				vehicle: {
					vehicleIdentificationNumber: null,
					manufacturer: null,
					model: null,
					licensePlate: {
						isSpecial: false,
						text: null,
					},
					yearOfConstruction: null,
					numberOfPreviousOwners: null,
				},
				oppositePerson: {
					title: null,
					firstName: null,
					lastName: null,
					street: null,
					houseNumber: null,
					city: {
						id: null,
					},
					phoneNumber: null,
					email: null,
				},
				oppositeLicensePlate: {
					isSpecial: false,
					text: null,
				},
				lawyerOffice: {
					id: null,
					name: null,
					houseNumber: null,
					street: null,
					phoneNumber: null,
					email: null,
					city: {
						id: null,
					},
				},
				lawyerOfficeReferenceNumber: null,
				rentalCarContract: {
					isDriverLicenseChecked: false,
					isIdentificationCardChecked: false,
					rentStartDate: null,
					kilometrage: null,
					vehicle: {
						id: null,
					},
				},
				customerConsultant: {
					id: null,
				},
				repairShop: {
					id: null,
				},
				signLocation: null,
				//images
				overviewImage: null,
				personalIDImage: null,
				drivingLicenseImage: null,
				policeReportImage: null,
			},
			vehicleRegistrationImageContent: null,
		};
	},
	methods: {
		clearCustomer() {
			this.apiData.customer = {
				id: null,
				gender: null,
				title: null,
				firstName: null,
				lastName: null,
				street: null,
				houseNumber: null,
				city: {
					id: null,
					zipCode: null,
					name: null,
				},
				phoneNumber: null,
				email: null,
				company: {
					name: null,
				},
			};
			this.customerCars = [];
		},
		clearLawyerOffice() {
			this.apiData.lawyerOffice = { city: {} };
		},
		getCustomerCars() {
			vehiclesApi
				.vehiclesCustomerIdGet(this.apiData.customer.id)
				.then(result => {
					this.customerCars = result.data;

					if (this.$route.query.vehicle_id) {
						this.apiData.vehicle = this.customerCars.find(car => car.id === parseInt(this.$route.query.vehicle_id));
					}
				})
				.catch(error => {});
		},
		next(args) {
			// Wenn keine Daten übergeben werden, wurde die Seite übersprungen
			if (args) {
				stateMerge(this.apiData, args);
			}
			this.$emit('scrollUp');
			this.pageRegister = this.getPageRegister();

			// Prüfen ob Customer übergeben wurde. Wenn ja, dann muss die Reihenfolge beim Kundenfahrzeug geändert werden wenn Kunde bereits Fahrzeuge hat
			this.pageIndex = this.pageRegister[++this.pageRegisterIndex];

			// Prüfen ob Anwalt übersprungen wird, dann muss MailToLawyer ebenfalls übersprungen werden
			// if (this.pageIndex === this.pageIndexEnum.MailToLawyer && args === null) {
			// 	this.pageIndex = this.pageRegister[++this.pageRegisterIndex];
			// }
			if (this.pageIndex === this.pageIndexEnum.MailToLawyer && args === null) {
				this.pageIndex = this.pageRegister[++this.pageRegisterIndex];
			}
		},
		previous() {
			const index = this.pageRegister[--this.pageRegisterIndex];
			if (index || index === 0) this.pageIndex = index;
		},
		getPageRegister() {
			const register = [];

			if (!this.isLevel1or4or7) {
				register.push(this.pageIndexEnum.OverviewImage);
			}

			register.push(this.pageIndexEnum.Accident);
			register.push(this.pageIndexEnum.OppositePerson);
			register.push(this.pageIndexEnum.DamageAssessor);

			register.push(this.pageIndexEnum.LawyerAuthority);

			if (!this.apiData.isSkipLawyerOffice) {
				if (this.apiData.lawyerOffice.id === null) {
					register.push(this.pageIndexEnum.ForeignLawyerOffice);
				}
			}

			if (!this.apiData.lawyerOffice.isEditable) {
				register.push(this.pageIndexEnum.MailToLawyer);
			}

			register.push(this.pageIndexEnum.Submit);

			return register;
		},
	},
};
</script>

<style>
#createDCWrapper > div {
	@apply flex-grow flex flex-col relative;
}
</style>
